var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ex1"},[_c('h3',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"base-demo"},[_c('vue-table-dynamic',{attrs:{"params":_vm.params},on:{"cell-click":_vm.tableCellClicked,"on-row-dblclick":_vm.onRowDoubleClick,"row-click":_vm.onRowClicked,"cell-contextmenu":_vm.cm},scopedSlots:_vm._u([{key:"column-1",fn:function(ref){
var props = ref.props;
return [_c('span',{style:({ color: props.cellData.color })},[_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-6",fn:function(ref){
var props = ref.props;
return [_c('span',{style:({
            color: props.cellData.color,
            'text-decoration': props.cellData.decoration,
            cursor: props.cellData.cursor,
          })},[_vm._v(_vm._s(props.cellData.value))])]}},{key:"column-7",fn:function(ref){
          var props = ref.props;
return [_c('span',{style:({
            color: props.cellData.color,
            'text-decoration': props.cellData.decoration,
            cursor: props.cellData.cursor,
          })},[_vm._v(_vm._s(props.cellData.value))])]}}])})],1),(_vm.dailyLog[0])?_c('div',{staticClass:"top-margin"},[_c('h1',{staticClass:"title is-4"},[_vm._v("Vrijeme provedeno na pauzi:")]),_c('brake-listing',{attrs:{"insideEvents":_vm.dailyLog[0].insideEvent}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }